// "מעבר לפרופיל" under a coach reply (2026-10-29 product decision). Navigation only — nothing here changes the profile
// or the plan. Every permanent setting that shapes the plan (weekly volume, training days, long-run day, goal, paces,
// level, max heart rate, the injury state) is changed in the profile, whose save offers the plan rebuild. The backend
// (llm/chat_redirects.py) always names the place with ONE exact phrase — PROFILE_PLACE — and the field in quotes; the
// button appears only then (also after a chat reload: the text carries it), and opens the profile at that field's card.

export const PROFILE_PLACE = "במסך 'פרופיל'";

// the field names the backend writes ("בשדה '…'") -> the profile card (data-testid="pf-<section>")
const FIELD_SECTION = [
  ["ק\"מ שבועי", 'training'], ['ימי אימון', 'training'], ['יום ריצה ארוכה', 'training'], ['רמה', 'training'],
  ['זמן מטרה', 'goal'], ['מצב פציעה', 'health'], ['דופק מקסימלי', 'physio'],
];

/** The profile card to open for this coach reply ('training' | 'goal' | 'health' | 'physio'), or null (no button). */
export function profileSectionFor(text) {
  const t = String(text || '');
  if (!t.includes(PROFILE_PLACE)) return null;
  const hit = FIELD_SECTION.find(([field]) => t.includes(`'${field}'`));
  return hit ? hit[1] : 'training';
}
